import { useState } from 'react'
import { columns, mobileColumns } from './column'
import ReactDataTable from '../../../../../components/_shared/Table/ReactDataTable'
import ReactExpandableTable from '../../../../../components/_shared/Table/ReactExpandableTable'
import useWindowSize from '../../../../../../utils/hooks/useWindowSize'
import ExpandableIncidetTable from './ExpandableIncidetTable'
const IncidentTable = ({
    handleOnRowClicked,
    pageCount,
    data,
    totaldata,
    location,
    userRole,
    tableOptions,
    handlePageClick,
    handleRowsPerPage,
    filteredData,
    handleColumnSort,
    isLoading,
    columnFilters = {},
    onColumnFilterChange,
    statusOptions = [],
}) => {
    const [currentRow, setCurrentRow] = useState(null)

    const size = useWindowSize()

    if (size?.width < 768) {
        return (
            <ReactExpandableTable
                data={data}
                mobileColumns={mobileColumns}
                isLoading={isLoading}
                pageCount={pageCount}
                activePage={tableOptions?.activePage}
                rowPerPages={tableOptions?.rowPerPages}
                removePagination={false}
                totaldata={totaldata}
                setCurrentRow={setCurrentRow}
                currentRow={currentRow}
                filteredData={filteredData}
                handleRowsPerPage={handleRowsPerPage}
                handlePageClick={handlePageClick}
                handleOnRowClicked={handleOnRowClicked}
                expandableComponent={ExpandableIncidetTable}
                handleColumnSort={handleColumnSort}
            />
        )
    }

    return (
        <>
            <ReactDataTable
                isLoading={isLoading}
                columns={columns(location, columnFilters, onColumnFilterChange, statusOptions)}
                data={data}
                totaldata={totaldata}
                pageCount={pageCount}
                activePage={tableOptions?.activePage}
                rowPerPages={tableOptions?.rowPerPages}
                removePagination={false}
                filteredData={filteredData}
                handleRowsPerPage={handleRowsPerPage}
                handleColumnSort={handleColumnSort}
                handleOnRowClicked={handleOnRowClicked}
                handlePageClick={handlePageClick}
            />
        </>
    )
}

export default IncidentTable
